import React from "react";
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export default function TableSkeleton({
  rowCount = 6,
  colCount = 6,
  containerSx = {},
}) {
  return (
    <TableContainer component={Paper} sx={{ minHeight: 320, ...containerSx }}>
      <Table>
        <TableHead>
          <TableRow>
            {[...Array(colCount)].map((_, idx) => (
              <TableCell key={idx}>
                <Skeleton variant="text" width={"100%"} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(rowCount)].map((_, rowIdx) => (
            <TableRow key={rowIdx}>
              {[...Array(colCount)].map((_, colIdx) => (
                <TableCell key={colIdx}>
                  <Skeleton variant="rectangular" height={30} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
